module.exports = __webpack_public_path__ + "static/img/ajibson.9989535.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/ajibson.jpg
// module id = cMFC
// module chunks = 1